import React from 'react';
import { CheckboxesBlock } from '../CheckboxesBlock';
import { InstructionsToExtractors } from '../../shared/InstructionsToExtractors';
import { IconAndTitle } from '../../shared/IconAndTitle';
import { HydratedBlockProps } from '../../BaseBlock';
import { AddOtherOptionCheckbox } from './settings/AddOtherOptionCheckbox';

export type CheckboxesEditorSettingsProps = {
  block: CheckboxesBlock & HydratedBlockProps;
  onChange: (updatedBlock: CheckboxesBlock) => void;
};

export const CheckboxesEditorSettings = ({
  block,
  onChange,
}: CheckboxesEditorSettingsProps): JSX.Element => (
  <>
    <IconAndTitle icon={block.icon} title={block.title} />
    <hr />
    <InstructionsToExtractors block={block} onChange={onChange} />
    <hr />
    <AddOtherOptionCheckbox block={block} onChange={onChange} />
    <hr />
  </>
);
